import styled from "styled-components";

export const ErrMsg = styled.span`
  color: red;
  font-family: var(--font-text);
  font-weight: 400;
  font-size: 9pt;
  padding: 4px 0px 0px 0.5px;
  width: auto;
`;
